import React, { ReactNode } from 'react';

import * as styles from './Banner.module.scss';

export type BannerType = 'info' | 'success' | 'warning' | 'danger' | 'primary';

type BannerProps = {
  children: ReactNode;
  className?: string;
  type?: BannerType;
};

export const Banner = ({ className, children, type, ...rest }: BannerProps) => {
  const classes = [styles.Banner];

  if (type) classes.push(styles[type]);
  if (className) classes.push(className);

  return (
    <div className={classes.join(' ')} role="alert" {...rest}>
      {children}
    </div>
  );
};
